import { Field as FieldT, FieldOptionBase } from 'api/tasks';
import {
  MultiSelectField,
  SingleSelectField,
} from '../components/organisms/tasks/fields';
import { byPosition } from './comparators/by-position';

const constructOptionByValue = <T extends FieldOptionBase = FieldOptionBase>(
  options: T[],
) => {
  const obj: Record<number, T> = {};
  const inactiveOptionByValue = (value) =>
    options.find((o) => o.value === value);

  options.forEach((x) => {
    if (x.active !== false) {
      obj[x.value] = x;
    } else {
      // this is done because we are not sure if there can be a case where 2 object can have the same value, 1 with active as false, and 1 with true
      // Mostly this shouldn't be the case, and we can remove this part, but just to be on the safer side
      obj[x.value] = inactiveOptionByValue(x.value)!;
    }
  });

  return obj;
};

export const FieldHelper = (
  field: FieldT | SingleSelectField | MultiSelectField,
) => {
  const metaData = field?.metaData;
  const activeOptions = (() => {
    return (metaData?.options ?? [])
      .filter(({ active }) => {
        return active;
      })
      .sort(byPosition);
  })();

  const allOptions = (() => {
    const options = metaData?.options;
    const byValue = constructOptionByValue(options ?? []);

    const nonDuplicateOptions = Object.values(byValue) ?? [];

    return nonDuplicateOptions.sort(byPosition);
  })();

  const originalOptions = (() => {
    return metaData?.options;
  })();

  return {
    options: {
      activeOptions,
      allOptions,
      originalOptions,
    },
  };
};
